export const B2C_FLAG_KEY = "Enable_B2C_On_Studies_Overseas";

export function useB2cFlag(): boolean {
  const raw2 = (process.env.NEXT_PUBLIC_B2C_FLOW ?? "");
  console.log("raw2", raw2, typeof raw2);
  const raw = (process.env.NEXT_PUBLIC_B2C_FLOW ?? "")
    .trim()
    .toLowerCase()
    .replace(/^["']|["']$/g, "");
  return raw === "true" || raw === "on" || raw === "1" || raw === "yes";
}